import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import vuetify from './vuetify'
import store from './store/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFontAwesome, faTelegramPlane, faVk } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { apiUrl } from './apiConfig'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
library.add(faFontAwesome, faTelegramPlane, faVk)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.config.productionTip = false

axios.defaults.withCredentials = true
axios.defaults.baseURL = apiUrl

new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
